import { Component, HostListener, OnInit, Renderer2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { BodyService, TranslationService } from './services/index';
import { setTheme } from 'ngx-bootstrap/utils';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { ruLocale } from 'ngx-bootstrap/locale';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  /* title = 'app works!'; */


  constructor(private translate: TranslateService,
    private bodyService: BodyService,
    private localeDatePickerService: BsLocaleService,
    private langService: TranslationService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    private titleService: Title) {

    translate.setDefaultLang('ru');
    this.langService.setLanguageFromUrl();
    setTheme('bs4');
    defineLocale('ru', ruLocale);
    this.localeDatePickerService.use('ru');
  }

  ngOnInit(): void {
    const lng = this.translate.currentLang;
    console.log(lng);

    this.translate.onLangChange.subscribe((e: any) => {
      const htmlElement = this.document.documentElement;
      this.renderer.setAttribute(htmlElement, 'lang', e.lang);
      this.titleService.setTitle(this.langService.translate("Title"));
    });
  }

  @HostListener('document:click', ['$event'])
  onClik(event: MouseEvent) {
    this.bodyService.emitClick(event);
  }
}
